.fieldGrid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  align-items: start;
}

.selectItem {
  width: 100%;
}
